export default {
  toMachine: val => Number(val) - 1,
  toHuman: val => Number(val) + 1,
};
